export const updateDimensions = (analyticsState, data) => {
  analyticsState = {
    ...analyticsState,
    dimensions: data,
  }
  return analyticsState
};
